export { default } from 'navigation/layouts/payment-layout';
